// extracted by mini-css-extract-plugin
export default {"checkoutBtn":"shoppingCart_checkoutBtn__CRoE1","title":"shoppingCart_title__Z3I0p","textContainer":"shoppingCart_textContainer__6-bmB","subText":"shoppingCart_subText__IENo-"};